import config from "../config";

/**
 * Checks the identity verification status for a given deposit.
 *
 * Sends a POST request to the verifyUserIdentity endpoint with the depositId.
 * If the user is already verified, resolves to { isVerified: true }.
 * Otherwise, returns { isVerified: false, verificationUrl }.
 *
 * @param {string} depositId - The deposit ID.
 * @returns {Promise<{isVerified: boolean, verificationUrl?: string}>} 
 *          A promise that resolves with an object indicating the identity status.
 * @throws {Error} If the API call fails.
 */
export async function checkIdentityStatus(depositId) {
  const endpointUrl = `${config.API_BASE_URL}/verifyUserIdentity`;
  try {
    const response = await fetch(endpointUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ depositId }),
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || "Failed to check identity status");
    }
    // Assume that if the returned status is "ALREADY_VERIFIED", the user is already verified.
    if (data.status === "ALREADY_VERIFIED") {
      return { isVerified: true };
    } else {
      // Otherwise, assume the user needs to verify, and the verification URL is returned.
      return { isVerified: false, verificationUrl: data.url };
    }
  } catch (error) {
    console.error("Error in checkIdentityStatus:", error);
    throw error;
  }
}